import ContainersReport from "../../../components/@reports/ContainersReport";

import { routeTypes } from "../../../../../hooks/useSystemRoutes"

export default function ContainersReportPage() {

    return (
        <ContainersReport 
            routeType={routeTypes.admin}
        />
    )
}       